import { Component, uiElement } from "@kluntje/core";
import { addClass, onEvent } from "@kluntje/js-utils/lib/dom-helpers";
import { DebuggerService } from "@kluntje/services";
import { Pagination } from "Components/sde-m-pagination/sde-m-pagination";
import { PAGINATION_CHANGED } from "Constants/eventTypes";
import { renderTemplate } from "Helper/renderHelper/renderTemplate";
import ArticleService from "Services/ArticleService";

export class SDEArticleOverview extends Component {
  private _pagination?: Pagination;

  @uiElement(".sde-m-article-overview__articles")
  private articlesBox: HTMLDivElement;

  private get apiBaseUrl(): string {
    return this.getAttribute("api-base-url") ?? `${location.origin}/wp-json/wp/v2/posts`;
  }

  private get pagination(): Pagination {
    if (this._pagination !== undefined) return this._pagination;

    const paginationElement = document.createElement("sde-m-pagination") as Pagination;
    addClass(paginationElement, "sde-m-pagination", "sde-m-article-overview__pagination");
    this._pagination = paginationElement;

    onEvent(paginationElement, PAGINATION_CHANGED, this.handlePaginationChange, this);

    this.appendChild(paginationElement);
    return paginationElement;
  }

  private get pageSize(): number {
    return 10;
  }

  private get currentPage(): number {
    return this.pagination.activeItem + 1;
  }

  protected afterComponentRender(): void {
    this.init();
  }

  private async init() {
    const articleResponse = await ArticleService.getArticles({
      apiBaseUrl: this.apiBaseUrl,
      pageSize: this.pageSize,
      page: 1,
    });

    if (!articleResponse || articleResponse.resultCount === 0) {
      DebuggerService.warn("No articles found");
      return;
    }

    if (articleResponse.pageCount > 1) {
      this.pagination.setAttribute("page-count", articleResponse.pageCount.toString());
    }
    const { contentTemplate } = await import("./sde-m-article-overview.template");
    renderTemplate(contentTemplate({ articles: articleResponse.results }), this.articlesBox, { clearSSRContent: true });
  }

  private async renderCurrentPage() {
    await this.renderPlaceholders();
    const articleResponse = await ArticleService.getArticles({
      apiBaseUrl: this.apiBaseUrl,
      pageSize: this.pageSize,
      page: this.currentPage,
    });

    if (!articleResponse || articleResponse.resultCount === 0) {
      DebuggerService.warn("No articles found");
      return;
    }

    const { contentTemplate } = await import("./sde-m-article-overview.template");
    renderTemplate(contentTemplate({ articles: articleResponse.results }), this.articlesBox, { clearSSRContent: true });
  }

  private async renderPlaceholders() {
    const { placeholderTemplate } = await import("./sde-m-article-overview.template");
    renderTemplate(placeholderTemplate(this.pageSize), this.articlesBox, { clearSSRContent: true });
  }

  private handlePaginationChange() {
    this.renderCurrentPage();
  }
}

customElements.define("sde-m-article-overview", SDEArticleOverview);
